// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
// slick
import $ from 'jquery';
import 'third/jquery.slick.js';

const fragments = {
  DESC_CONTAINER: '[data-fragment="PromoLPGallery.descriptionContainer"]',
};

class PromoLPGallery extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {

    // set title and description in the container
    function refreshDescription() {
      const wrapper = document.querySelector('.promo-lp-gallery');
      const currentSlide = document.querySelector('.slick-current img');
      const container = document.querySelector(fragments.DESC_CONTAINER);
      const title = currentSlide.dataset.title;
      const description = currentSlide.getAttribute('alt');
      const pEl = document.createElement('div');
      pEl.classList.add('promo-lp-gallery__description-content');
      if (description.length > 0) {
        wrapper.classList.remove('no-description');
        container.classList.remove('promo-lp-gallery__description--empty');
        pEl.innerHTML = `
                    <span>${title}</span>
                    <p>${description}</p>
                    `;
      } else {
        wrapper.classList.add('no-description');
        container.classList.add('promo-lp-gallery__description--empty');
      }
      container.innerHTML = '';
      container.appendChild(pEl);
    }

    // adjust height of the arrows
    $(this.element).on('setPosition', function(event, slick){
      const sliderHeight = slick.listHeight;
      slick.$nextArrow.css('height', sliderHeight);
      slick.$prevArrow.css('height', sliderHeight);
    });

    $(this.element).on('afterChange', function(event, slick){
      refreshDescription();
    });

    if (document.documentElement.getAttribute('dir') === 'rtl') {
      $(this.element).slick({
        rtl: true,
        mobileFirst: true,
        centerMode: true,
        infinite: false,
        arrows: true,
        dots: true,
        touchThreshold: 10,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        rows: 0,
        prevArrow: $('.promo-lp-gallery__nav-item--prev'),
        nextArrow: $('.promo-lp-gallery__nav-item--next'),
      });
    } else {
      $(this.element).slick({
        mobileFirst: true,
        centerMode: true,
        infinite: false,
        arrows: true,
        dots: true,
        touchThreshold: 10,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        rows: 0,
        prevArrow: $('.promo-lp-gallery__nav-item--prev'),
        nextArrow: $('.promo-lp-gallery__nav-item--next'),
      });
    }

    refreshDescription();

		$(window).resize(() => {
			$(this.element).slick('resize');
		});
	}

	willUnmount() {
	}
}


export default PromoLPGallery;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/promoLP/PromoLPGallery.js